<template>
    <div class="w-full">
        <!-- Partners -->
        <div class="orc-vert-limit-content py-6" v-if="sponsors && sponsors.length > 0">
            <h1 class="text-2xl mb-6 mt-12"><i class="el-icon-wallet mr-3"></i>Partners</h1>

            <el-row :gutter="10">
                <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" v-for="sponsor in sponsors" :key="sponsor.id">
                    <a :href="sponsor.websiteURL">
                        <el-tooltip class="item" effect="dark" :content="sponsor.name" placement="top">
                            <img :src="resolve(sponsor.logo.url)" class="orc-logo w-full">
                        </el-tooltip>
                    </a>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Sponsors",
        props: ['branchId'],
        watch: {
            branchId: function (newVal, val) {
                this.getSponsors()
            }
        },
        data() {
            return {
                activeName: '1',
                sponsors: this.getSponsors()
            }
        },
        methods: {
            getSponsors() {
                this.$http.get(`sponsors?branch=${this.branchId}`).then((response) => {
                    this.sponsors = response.data
                }).catch(function (error) {
                    console.log(error)
                })
            },
            resolve(img) {
                return this.$http.defaults.baseURL + 'resources/' + img
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/sponsors/Sponsors.vue